import * as documentTypes from '../constants/documentTypes';

const text = {
  [documentTypes.UNKNOWN]: 'Unknown',
  [documentTypes.BANK_STATEMENT]: 'Bank Statement',
  [documentTypes.PAYSLIP]: 'Pay Slip',
  [documentTypes.TAX_FORM]: 'Tax Form',
  [documentTypes.INVOICE]: 'Invoice',
  [documentTypes.UTILITY_BILL]: 'Utility Bill',
  [documentTypes.CHECK]: 'Check',
  [documentTypes.DRIVING_LICENSE]: 'Driving License',
  [documentTypes.SOCIAL_SECURITY_CARD]: 'Social Security Card',
  [documentTypes.FINANCIAL_STATEMENT]: 'Financial Statement',
  [documentTypes.BUSINESS_FILING]: 'Business Filing',
  [documentTypes.BENEFITS_STATEMENT]: 'Benefits Statement',
  [documentTypes.INSURANCE_STATEMENT]: 'Insurance Statement',
  [documentTypes.LEASE]: 'Lease',
  [documentTypes.INVESTMENT_STATEMENT]: 'Investment Statement',
  [documentTypes.CREDIT_CARD_STATEMENT]: 'Credit Card Statement',
  [documentTypes.BANK_LETTER]: 'Bank Letter',
};

export const getDocumentTypeText = (type) => text[type];
